var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C1F7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16C7 20.9706 11.0294 25 16 25C20.9706 25 25 20.9706 25 16C25 11.0294 20.9706 7 16 7C11.0294 7 7 11.0294 7 16ZM19.9145 12.8712C20.2554 13.1837 20.2784 13.7133 19.966 14.0541L15.3614 19.0773C15.207 19.2457 14.9907 19.3436 14.7624 19.3487C14.534 19.3536 14.3137 19.2651 14.1522 19.1036L12.0592 17.0106C11.7322 16.6837 11.7322 16.1535 12.0592 15.8266C12.3861 15.4997 12.9162 15.4997 13.2432 15.8266L14.7179 17.3014L18.7316 12.9227C19.0441 12.5818 19.5737 12.5588 19.9145 12.8712Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryApprove);
export default __webpack_public_path__ + "static/media/history-approve.c07ade6553229f7705f24db79804cd36.svg";
export { ForwardRef as ReactComponent };